import { render } from "./NewMileageCase.vue?vue&type=template&id=821d3c40"
import script from "./NewMileageCase.vue?vue&type=script&lang=js"
export * from "./NewMileageCase.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/NewMileageCase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "821d3c40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('821d3c40', __exports__)) {
    console.log('reload')
    api.reload('821d3c40', __exports__)
  }
  
  module.hot.accept("./NewMileageCase.vue?vue&type=template&id=821d3c40", () => {
    console.log('re-render')
    api.rerender('821d3c40', render)
  })

}


export default __exports__